/* eslint-disable max-len */
/* eslint-disable no-unused-vars */

import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faFileExcel,
  faCloudUploadAlt,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import './BulkUploadModal.scss';

const BulkUploadModal = ({
  show, toggle, handleExcelUpload,
}) => {
  const showHideClassName = show ? 'bulk-upload-modal display-block' : 'bulk-upload-modal display-none';
  const fileInputRef = useRef(null);

  const downloadSampleExcel = () => {
    const ws = XLSX.utils.json_to_sheet([
      {
        plantCode: '1234',
        materialCode: '0001',
        orderQty: '100',
        requiredDate: '10-Jun-2026',
      },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sample_Indents');
    XLSX.writeFile(wb, 'Sample_Manual_Indents.xlsx');
  };

  const onFileUpload = (e) => {
    handleExcelUpload(e);
    toggle();
  };

  return (
    <div className={showHideClassName}>
      <section className="bulk-modal-main">
        <div className="modal-header">
          <div className="header-text">
            <h3>Bulk Upload Manual Indents</h3>
            <p className="description">
              Follow the steps below to correctly format and upload your indents. Your required fields are:
            </p>
            <div className="badge-container">
              <span className="badge">plantCode</span>
              <span className="badge">materialCode</span>
              <span className="badge">requiredDate (DD-MMM-YYYY) </span>
              <span className="badge">orderQty</span>
            </div>
            <p className="description">
              Please note that the required date should be in the format DD-MMM-YYYY. (e.g. 10-Jun-2026)
            </p>
          </div>
          <button type="button" className="close-button" onClick={toggle}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-body">
          <div className="step-container">
            <div className="step-indicator">1</div>
            <div className="step-content">
              <h5>Download Template</h5>
              <p>Grab a copy of the pre-formatted Excel file.</p>
              <button
                type="button"
                className="btn-download"
                onClick={downloadSampleExcel}
              >
                <FontAwesomeIcon icon={faArrowDown} className="icon-left" />
                Download Sample.xlsx
              </button>
            </div>
          </div>
          {/* <div className="step-connector"></div> */}
          <div className="step-container">
            <div className="step-indicator">2</div>
            <div className="step-content">
              <h5>Upload Completed File</h5>
              <p>Upload the filled template to automatically process entries.</p>
              <div
                className="upload-dropzone"
                onClick={() => fileInputRef.current?.click()}
                role="button"
                tabIndex={0}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept=".xlsx, .xls"
                  onChange={onFileUpload}
                />
                <div className="dropzone-content">
                  <div className="icon-circle">
                    <FontAwesomeIcon icon={faCloudUploadAlt} />
                  </div>
                  <h6>Click to browse files</h6>
                  <span className="file-hint">Supports .xlsx and .xls</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BulkUploadModal;
